import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\components\\Header.tsx");
